module.exports = __webpack_public_path__ + "img/switch-event.2207324f.svg";